import * as Yup from 'yup'
import { NOT_APPLICABLE_FIELD_VALUE } from 'core/common/constants/datasheet'
import i18n from 'core/common/i18n'
import { regexSKU } from 'core/common/utils/regex'

export const SimpleProductDetailsSchema = Yup.object().shape({
  sku: Yup.string()
    .trim()
    .min(1, i18n.t('product.validations.minSize', { count: 1 }))
    .max(50, i18n.t('product.validations.maxSize', { count: 50 }))
    .matches(regexSKU, i18n.t('product.validations.onlyCharacters'))
    .required(i18n.t('product.validations.required')),
  ean: Yup.string()
    .trim()
    .test('ean-or-not-applicable', i18n.t('product.validations.ean'), value => {
      if (value === NOT_APPLICABLE_FIELD_VALUE) return true

      return Yup.string()
        .trim()
        .min(8, i18n.t('product.validations.minSize', { count: 8 }))
        .max(14, i18n.t('product.validations.maxSize', { count: 14 }))
        .ean()
        .isValidSync(value)
    })
    .required(i18n.t('product.validations.required')),
  uploadedImages: Yup.array().of(Yup.object()).required(i18n.t('product.validations.required')),
})

export const VariationProductDetailsSchema = Yup.lazy(obj => {
  return Yup.object().shape({
    variations: Yup.array().of(
      Yup.object().shape({
        sku: Yup.string()
          .trim()
          .min(1, i18n.t('product.validations.minSize', { count: 1 }))
          .max(50, i18n.t('product.validations.maxSize', { count: 50 }))
          .required(i18n.t('product.validations.required'))
          .trim(i18n.t('product.validations.required'))
          .skuUnique(i18n.t('product.validations.duplicatedSKU'), obj?.variations)
          .matches(regexSKU, i18n.t('product.validations.onlyCharacters')),
        ean: Yup.string()
          .trim()
          .test('ean-or-not-applicable', i18n.t('product.validations.ean'), value => {
            if (value === NOT_APPLICABLE_FIELD_VALUE) return true

            return Yup.string()
              .trim()
              .min(8, i18n.t('product.validations.minSize', { count: 8 }))
              .max(14, i18n.t('product.validations.maxSize', { count: 14 }))
              .ean()
              .isValidSync(value)
          })
          .required(i18n.t('product.validations.required')),
        images: Yup.array().of(Yup.object()).required(i18n.t('product.validations.required')),
      })
    ),
  })
})
